<ng-template #template>
  @if (loadingWrapper.errorLoading$ | async; as error) {
    <div>
      <div class="row col-12">
        <div class="card">
          <div class="card-body">
            <p>{{ errorMessage }}</p>
            <p>If the problem persists, please contact the IT Service Desk at <a href="mailto:itservicedesk@kenan-flagler.unc.edu">itservicedesk&#64;kenan-flagler.unc.edu</a>.</p>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  }
  <ng-template #loading>
    <div class="widget-loading text-center">
      <i class="fas fa-circle-notch fa-spin"></i>
    </div>
  </ng-template>
</ng-template>
